import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import { locationsCol } from "../../../firebase.config";
import { getDocs } from "firebase/firestore";
import { Location } from "../../interfaces";

export const SearchForm = () => {
  const [locationId, setLocationId] = useState<string>("");
  const [locations, setLocations] = useState<any>(null);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    async function fetchLocations() {
      const data = await getDocs(locationsCol);
      const results = data.docs.map((doc) => ({
        ...doc.data(),
      }));
      setLocations(results.map((r: Location) => r.id));
    }
    fetchLocations();
  }, []);

  const navigate = useNavigate();

  const handleSearchClick = () => {
    if (!locations.includes(locationId.toLowerCase())) {
      setError(true);
      return;
    }
    setError(false);
    navigate(`${locationId}`);
    setLocationId("");
  };

  return (
    <Box
      sx={{
        width: "100vw",
        paddingTop: "3rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "1.5rem",
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: "600" }}>
        Pronađite svoj objekt
      </Typography>
      <TextField
        id="outlined-basic"
        label="Jedinstveni kod objekta"
        variant="outlined"
        value={locationId}
        sx={{ width: "400px", maxWidth: "80%" }}
        onChange={(e) => setLocationId(e.target.value)}
      />
      {error && (
        <Typography variant="body2" sx={{ color: "red" }}>
          Traženi objekt ne postoji
        </Typography>
      )}
      <ButtonGroup size="large">
        <Button
          color="error"
          onClick={() => setLocationId("")}
          disabled={!locationId}
        >
          Očisti
        </Button>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#F1B317",
            color: "#595959",
            "&:hover": {
              backgroundColor: "#F1B317",
              color: "white",
            },
          }}
          onClick={handleSearchClick}
          disabled={!locationId}
        >
          Traži
        </Button>
      </ButtonGroup>
    </Box>
  );
};
